import React from "react";

class Footer extends React.Component {
  render(){
    return(
      <footer>&copy; Eric Kinuthia</footer>
    )
  }
}

export default Footer;